(function($) {

  var $home_swiper = $('.home-carousel');
  if( $home_swiper.length ) {

    const swiper = new Swiper('.home-carousel', {
      grabCursor: false,
      navigation: false,
      mousewheel: false,
      keyboard: false,
      draggable: false,
      noSwiping: true,
      effect: "creative",
      slidesPerView: 1,
      autoplay: true,
      speed: 1000,
      loop: true,
      creativeEffect: {
        prev: {
          translate: ["100%", 0,20],
          opacity: 0
        },
        next: {
          shadow: true,
          translate: [-60, 0, -80],
        },
      },
      // breakpoints: {
      //   576: {
      //     slidesPerView: 1.25,
      //     spaceBetween: 30,
      //   },
      //   768: {
      //     slidesPerView: 1.5,
      //     spaceBetween: 30,
      //   },
      //   1024: {
      //     slidesPerView: 2.25,
      //     spaceBetween: 30,
      //   },
      //   1400: {
      //     slidesPerView: 2.25,
      //     spaceBetween: 30,
      //   },
      //   1700: {
      //     slidesPerView: 2.25,
      //     spaceBetween: 50,
      //   },
      // }
    });

  }

})(jQuery);